import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { Utils } from "src/app/common/utils";
import { DashCred } from "src/app/models/dash";
import { VproService } from "src/app/service/vpro/vpro.service";
import Swal from "sweetalert2";
import { sortBy } from "underscore";
import { NgbCalendar, NgbDate, NgbDateParserFormatter, NgbDatepickerConfig } from "@ng-bootstrap/ng-bootstrap";
import { from, Subscription } from "rxjs";
const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});

@Component({
  selector: "app-appointments-past",
  templateUrl: "./appointments-past.component.html",
  styleUrls: ["./appointments-past.component.css"],
})
export class AppointmentsPastComponent implements OnInit {
  appointments: any = [];
  //Pagination Parameters
  page: number = 1;
  pagesize: number = Utils.DEFAULT_PAGE_COUNT_SHOW;
  pageCount: number[] = Utils.PAGE_COUNT;
  collectionSize: number;
  findAppointmentForm: UntypedFormGroup;
  appointmentType = Utils.APPOINTMENT_TYPE;
  noAppointments: boolean = false;
  filterActive: boolean = false;
  dateFormat = Utils.DATE_FORMAT;
  activeBtn: string;
  maxDate: { year: number; month: number; day: number };
  aid: any;
  formSub: Subscription;
  formsub: Subscription;
  public invalidForm: boolean;
  public minDate: string;
  hoveredDate: NgbDate | null = null;

  fromDate: NgbDate | null;
  toDate: NgbDate | null;
  constructor(
    private service: VproService,
    private spinner: NgxSpinnerService,
    private _formBuilder: UntypedFormBuilder,
    private router: Router,
    private utils: Utils,
    private config: NgbDatepickerConfig,
    public formatter: NgbDateParserFormatter,
    private calendar: NgbCalendar,
  ) {
    const current = new Date();
    this.maxDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate(),
    };
  }

  ngOnInit() {
    this.findAppointmentForm = this._formBuilder.group({
      patName: [""],
      apDate: [null],
      fromDate: ["", [Validators.required]],
      toDate: ["", [Validators.required]]
    });
  }

  onDateSelection(date: NgbDate, datepicker: any) {

    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;

    } else if (this.fromDate && !this.toDate && date) {
      this.toDate = date;
      console.log(" this.fromDate", this.fromDate)
      console.log(" this.toDate", this.toDate)
      datepicker.close();
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  isHovered(date: NgbDate) {
    return (
      this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    // console.log("this.fromDate is inside", this.fromDate);
    // console.log("this.toDate is inside", this.toDate);
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    // console.log("this.fromDate is range", this.fromDate);
    // console.log("this.toDate is range", this.toDate);
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }
  getAppointments(type: string = "", pg: number = 1) {
    let val = this.findAppointmentForm.value;
    let data = {};
    this.activeBtn = type;
    this.page = pg;
    this.filterActive = type ? true : false;
    let drids;
    let userRoles = JSON.parse(localStorage.getItem("LogUsrTyp"));
    if (this.utils.checkRoleType(Utils.USER_TYPE.physician, userRoles)) {
      drids = parseInt(localStorage.getItem("uid"));
    }
    if (this.fromDate == null) {
      this.findAppointmentForm['fromDate'] = null
    }
    if (this.toDate == null) {
      this.findAppointmentForm['toDate'] = null
    }
    if (this.fromDate) {
      data["fromDate"] = this.fromDate.year + "-" + this.fromDate.month + "-" + this.fromDate.day
    }
    if (this.toDate) {
      data["toDate"] = this.toDate.year + "-" + this.toDate.month + "-" + this.toDate.day
    }
    if (type === "INPERSON") {
      data["apttype"] = [this.appointmentType.IN_PERSON];
    }
    if (type === "ONLINE") {
      data["apttype"] = [
        this.appointmentType.AUDIO,
        this.appointmentType.VIDEO,
      ];
    }
    if (val.apDate) {
      data["apdate"] =
        val.apDate.year + "-" + val.apDate.month + "-" + val.apDate.day;
    }
    if (val.patName) {
      data["pat_name"] = val.patName;
    }
    this.spinner.show();
    this.service
      .getAppointmentDetails(
        data,
        `type=${Utils.PAST_APPOINTMENT}&drid=${drids}`,
        `&page=${this.page}&count=${this.pagesize}`
      )
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.appointments = res["result"];
          console.log("PAST APPOINTMENTS", this.appointments);
          this.collectionSize = res["result"].length;
          console.log(" collectionSize", this.collectionSize);
          if (this.appointments && this.appointments.length) {
            this.noAppointments = false;
          } else {
            this.noAppointments = true;
            this.page = 1;
            this.pagesize = Utils.DEFAULT_PAGE_COUNT_SHOW;
          }
        },
        (error) => {
          this.spinner.hide();
          let msg = "Something went wrong. Please try again.";
          if (error && error.error && error.error.internalError) {
            this.showToast("error", error.error.internalError);
            if (error.error.internalError)
              this.appointments = {};
            return;
          }
          this.showToast("error", msg);

        }
      );
  }

  goToPrescription(apt) {
    // check if appointment status is not completed
    if (apt && apt.schedule_stat) {
      if ([Utils.APPOINTMENT_STATUS.NOT_COMPLETED].includes(apt.schedule_stat)) {
        // Sweet Alert
        Swal.fire({
          position: "top",
          type: "success",
          title: "Consultation summary not available",
          showConfirmButton: false,
          timer: 1700,
        });
      } else {
        if (apt.apttype == Utils.APPOINTMENT_TYPE.IN_PERSON) {
          this.router.navigate([`/phydash/${apt.pid}`], { queryParams: { cid: apt.cid } });
        } else {
          this.router.navigate(['/physician/consultation'], { queryParams: { pid: apt.pid, drid: apt.drid, aid: apt.aid, aptid: apt.aptid } });
        }
        //this.router.navigate([`/patient/consultation/${apt.aptid}`]);
      }
    }

  }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title,
    });
  }

  pageChanged() {
    this.getAppointments(this.activeBtn, this.page);
  }


}
